function format(seconds: number) : string {
  const isoString = new Date(seconds * 1000).toISOString();

  if (seconds < 3600) {
    return isoString.substr(14, 5);
  }
  return isoString.substr(11, 8);
}

export default {
  format,
};
